import { render, staticRenderFns } from "./Automati.vue?vue&type=template&id=4ab4d76b&"
import script from "./Automati.vue?vue&type=script&lang=js&"
export * from "./Automati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports